import { render, staticRenderFns } from "./EditGracePeriod.vue?vue&type=template&id=9b9ffe9e"
import script from "./EditGracePeriod.vue?vue&type=script&setup=true&lang=js"
export * from "./EditGracePeriod.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports